export enum BulkIntegrationActionType {
  LockUnlock = 'LockUnlock',
  MoveServerIntegrations = 'MoveServerIntegrations',
  UpdateRunTimes = 'UpdateRunTimes',
  None = 'None'
}
